import { mangaList } from '@/mocks/manga';

function byViews(a: { views: string }, b: { views: string }) {
  const num = (s: string) => parseInt(s.replace('万', ''), 10) || 0;
  return num(b.views) - num(a.views);
}

const rankStyle = (index: number) =>
  index < 3
    ? 'bg-primary-500 text-background-50'
    : 'bg-secondary-200 text-secondary-900';

export default function Ranking() {
  const ranked = [...mangaList].sort(byViews).slice(0, 10);
  const columns: typeof ranked[] = [
    ranked.filter((_, i) => i % 2 === 0),
    ranked.filter((_, i) => i % 2 === 1),
  ];

  return (
    <section id="ranking" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-end justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
              <i className="ri-trophy-fill" /> 每周更新
            </span>
            <h2 className="font-display mt-3 text-2xl font-bold text-foreground-900 md:text-4xl">
              人气排行
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              综合阅读热度与收藏人气，看大家都在追什么。
            </p>
          </div>
          <span className="hidden whitespace-nowrap text-sm text-foreground-500 sm:block">
            TOP 10 · 共 {mangaList.length} 部
          </span>
        </div>

        <div className="mt-8 grid gap-6 lg:grid-cols-2">
          {columns.map((col, ci) => (
            <ol
              key={ci}
              className="flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-4"
            >
              {col.map((manga) => {
                const index = ranked.indexOf(manga);
                return (
                  <li key={manga.id}>
                    <article className="group flex items-center gap-3">
                      <span
                        className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-display text-base font-bold ${rankStyle(index)}`}
                      >
                        {index + 1}
                      </span>
                      <div className="h-16 w-12 shrink-0 overflow-hidden rounded-md">
                        <img
                          src={manga.cover}
                          alt={`${manga.title} 漫画封面`}
                          title={`${manga.title} 人气排行第${index + 1}名`}
                          className="h-full w-full object-cover object-top"
                        />
                      </div>
                      <div className="min-w-0 flex-1">
                        <h3 className="truncate font-display text-sm font-bold text-foreground-900 md:text-base">
                          {manga.title}
                        </h3>
                        <p className="mt-0.5 truncate text-xs text-foreground-500">
                          {manga.category} · 已更 {manga.chapters} 话
                        </p>
                      </div>
                      <div className="shrink-0 text-right">
                        <p className="flex items-center justify-end gap-1 text-xs text-foreground-600">
                          <i className="ri-star-fill text-accent-500" />
                          {manga.rating.toFixed(1)}
                        </p>
                        <p className="mt-0.5 text-xs text-foreground-500">{manga.views} 人气</p>
                      </div>
                    </article>
                  </li>
                );
              })}
            </ol>
          ))}
        </div>
      </div>
    </section>
  );
}